import { Buffer } from 'buffer';
import { TestDataBuffer } from "@/types";

export const testDataOnStart: TestDataBuffer = {
    global: [],
    voice: {
      textMatrix: [],
      timestamps: [],
      activitiTimestamps: [],
      audio: Buffer.alloc(1)
    },
    writing: {
      behaviour: [],
      image: Buffer.alloc(1)
    },
    printing: {
      behaviour: []
    }
  };
  
// Адрес бэкенда вычисляется от текущего хоста: api.<этот-хост>.
// Благодаря этому фронт можно копировать на любой домен без правок кода —
// достаточно, чтобы поддомен api.<домен> указывал на бэкенд.
function resolveServerUrl(): string {
  if (
    typeof window !== "undefined" &&
    window.location &&
    window.location.hostname
  ) {
    const { protocol, hostname } = window.location;

    // Локальная разработка: бэкенд слушает порт 9612 на localhost
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:9612/";
    }

    return `${protocol}//api.${hostname}/`;
  }

  // Фолбэк на случай сборки/рендера без window
  return "https://api.localhost/";
}

export const serverUrl = resolveServerUrl();

// Текущая версия приложения. Обновляйте с каждой итерацией.
export const APP_VERSION = "0.6.0";

// Резервное число требуемых попыток, если сервер не вернул значение.
export const REQUIRED_ATTEMPTS_FALLBACK = 5;
